var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { lg: 7, md: 9, sm: 12, span: 6, xl: 6, xs: 24 } },
            [
              _c("img", {
                staticStyle: { width: "100%" },
                attrs: { src: "images/anze-product.png" },
              }),
            ]
          ),
          _c(
            "el-col",
            { attrs: { lg: 16, md: 14, sm: 12, span: 18, xl: 18, xs: 24 } },
            [
              _c(
                "div",
                { staticStyle: { "margin-left": "16px" } },
                [
                  _c("h2", [
                    _vm._v("\n\t\t\t\t\t泰康\n\t\t\t\t\t"),
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("电梯雇主"),
                    ]),
                    _vm._v("\n\t\t\t\t\t责任险\n\t\t\t\t"),
                  ]),
                  _c("div", { staticStyle: { color: "red" } }, [
                    _vm._v("电梯行业 | 行业超低价 | 全线上操作"),
                  ]),
                  _c("p", [
                    _vm._v("\n\t\t\t\t\t① 投保简便支持月单\n\t\t\t\t\t"),
                    _c("br"),
                    _vm._v("\n\t\t\t\t\t② 3人起保，最高可保100万\n\t\t\t\t\t"),
                    _c("br"),
                    _vm._v(
                      "\n\t\t\t\t\t③ 社保用药免赔100元后100%赔付\n\t\t\t\t\t"
                    ),
                    _c("br"),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "medium", type: "warning" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handleInsure.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("立即投保")]
                  ),
                  _c("br"),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-top": "25px" },
                      attrs: {
                        loading: _vm.isDownLoading,
                        icon: "el-icon-download",
                        size: "medium",
                        type: "text",
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.handleDownLoad.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("\n\t\t\t\t\t下载泰康险职业类别表\n\t\t\t\t")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.currentStep,
            callback: function ($$v) {
              _vm.currentStep = $$v
            },
            expression: "currentStep",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "保险详情", name: "0" } },
            [
              _c(
                "el-card",
                [
                  _c("avue-crud", {
                    ref: "plan",
                    attrs: {
                      data: _vm.dataPlan,
                      option: _vm.optionPlan,
                      "span-method": _vm.spanMethodPlan,
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-card",
                [
                  _c("el-row", { attrs: { justify: "center", type: "flex" } }, [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-weight": "500",
                          color: "Red",
                          "margin-bottom": "20px",
                        },
                      },
                      [_vm._v("短期保费=年保费*比例")]
                    ),
                  ]),
                  _c(
                    "avue-crud",
                    {
                      ref: "crud",
                      attrs: { data: _vm.dataBenefit, option: _vm.optionTKDQ },
                    },
                    [_c("template", { slot: "header" })],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-card",
                { attrs: { header: "批增保费" } },
                [
                  _c("el-row", { attrs: { justify: "center", type: "flex" } }, [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-weight": "500",
                          color: "Red",
                          "margin-bottom": "20px",
                        },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t批增保费=（每人保费*（剩余保险天数/总保险天数））*人数\n\t\t\t\t\t"
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "常见问题", name: "1" } },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 20 } }, [
                    _c(
                      "ul",
                      _vm._l(_vm.dataQA, function (qa) {
                        return _c(
                          "li",
                          { key: qa.question },
                          [
                            _c("div", [
                              _c("span", { staticClass: "start-zimu" }, [
                                _vm._v("Q"),
                              ]),
                              _c(
                                "span",
                                { staticStyle: { "font-weight": "bold" } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(qa.question) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                            ]),
                            _c("p"),
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticClass: "start-zimu",
                                  staticStyle: {
                                    "background-color": "MediumSeaGreen",
                                  },
                                },
                                [_vm._v("A")]
                              ),
                              qa.question ===
                              "泰康在线的电梯雇主责任险保险责任范围包括哪些？"
                                ? _c("span", [
                                    _c("span", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t在保险期间内，凡被保险人的雇员在中华人民共和国境内（不包括港、澳、台地区）因下列情形所致伤、残或死亡，依照中华人民共和国法律（不包括港、澳、台地区法律）应由被保险人承担的经济赔偿责任，保险人按照本保险合同约定负责赔偿：\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                    ]),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(
                                        "（一）在工作时间和工作场所内，因工作原因发生意外事故受到伤害；"
                                      ),
                                    ]),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t（二）工作时间前后在工作场所内，从事与工作有关的预备性或者收尾性工作因意外事故受到伤害；\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                    ]),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(
                                        "（三）在工作时间和工作场所内，因履行工作职责受到暴力等意外伤害；"
                                      ),
                                    ]),
                                    _c("span", [
                                      _vm._v("（四）被诊断、鉴定为职业病；"),
                                    ]),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(
                                        "（五）因公外出期间，由于工作原因受到伤害或者发生事故下落不明；"
                                      ),
                                    ]),
                                    _c("br"),
                                    _c("span", { staticClass: "red-bold" }, [
                                      _vm._v(
                                        "（六）在上下班途中，因发生交通及其他意外事故受到伤害；"
                                      ),
                                    ]),
                                    _c("br"),
                                    _c("span", { staticClass: "red-bold" }, [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t（七）在工作时间和工作岗位，突发疾病死亡或者在48小时之内经抢救无效死亡；\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                    ]),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(
                                        "（八）在抢险救灾等维护国家利益、公共利益活动中受到伤害；"
                                      ),
                                    ]),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t（九）原在军队服役，因战、因公负伤致残，已取得革命伤残军人证，到被保险人处工作后旧伤复发；\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                    ]),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(
                                        "（十）法律、行政法规规定应当认定为工伤的其他情形。"
                                      ),
                                    ]),
                                    _c("br"),
                                  ])
                                : qa.question ===
                                  "泰康在线电梯雇主责任险有哪些责任不保？"
                                ? _c("span", [
                                    _c("span", [
                                      _vm._v("以下情况不属于保险责任。"),
                                    ]),
                                    _c("br"),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { "font-weight": "bold" },
                                      },
                                      [
                                        _vm._v(
                                          "一、下列原因造成雇员伤、残或死亡的，保险人不负责赔偿："
                                        ),
                                      ]
                                    ),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(
                                        "（一）投保人、被保险人及其代表的故意和重大过失行为；"
                                      ),
                                    ]),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(
                                        "（二）战争、敌对行动、军事行为、武装冲突、罢工、骚乱、暴动、恐怖活动；"
                                      ),
                                    ]),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(
                                        "（三）核辐射、核爆炸、核污染及其他放射性污染；"
                                      ),
                                    ]),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(
                                        "（四）大气污染、土地污染、水污染及其他各种污染；"
                                      ),
                                    ]),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(
                                        "（五）地震及其次生灾害、海啸及其次生灾害、飓风及其次生灾害；"
                                      ),
                                    ]),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(
                                        "（六）非被保险人的雇员所遭受的伤害；"
                                      ),
                                    ]),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v("（七）行政行为或司法行为；"),
                                    ]),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(
                                        "（八）被保险人雇员接触、使用含有放射性物质的材料；"
                                      ),
                                    ]),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(
                                        "（九）被保险人雇员接触、使用石棉、石棉制品或含有石棉成份的物质；"
                                      ),
                                    ]),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(
                                        "（十）被保险人雇员患职业病以外的疾病、传染病、分娩、流产、药物过敏。"
                                      ),
                                    ]),
                                    _c("br"),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { "font-weight": "bold" },
                                      },
                                      [
                                        _vm._v(
                                          "二、雇员发生下列情形并导致伤、残或死亡的，保险人不负责赔偿："
                                        ),
                                      ]
                                    ),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(
                                        "（一）故意行为、犯罪行为、违反治安管理法律、法规和规章；"
                                      ),
                                    ]),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v("（二）自伤、自杀、打架、斗殴；"),
                                    ]),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(
                                        "（三）因受酒精、毒品、药品影响造成自身人身伤亡；"
                                      ),
                                    ]),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t（四）无驾驶证、驾驶证失效或者被依法扣留、暂扣、吊销、注销期间驾驶机动车，驾驶与驾驶证载明的准驾车型不相符合的机动车，持审验不合格的驾驶证驾驶机动车；\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                    ]),
                                    _c("br"),
                                    _c("span", { staticClass: "red-bold" }, [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t（五）无国家有关部门核发的有效操作资格证而使用各种专用机械、特种设备或特种车辆或类似设备装置的；\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                    ]),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t（六）从事潜水、跳伞、热气球运动、攀岩运动、探险活动、武术比赛、摔跤比赛、特技表演、赛马、赛车等高风险活动；\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                    ]),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t（七）在中华人民共和国境外（包括香港、澳门、台湾地区）所发生的被保险人雇员的伤、残或死亡；\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                    ]),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(
                                        "（八）在被保险人被依法取缔、关闭或吊销营业执照期间发生的伤、残或死亡。"
                                      ),
                                    ]),
                                    _c("br"),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { "font-weight": "bold" },
                                      },
                                      [
                                        _vm._v(
                                          "三、对于下列损失、费用或责任，保险人不负责赔偿："
                                        ),
                                      ]
                                    ),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(
                                        "（一）被保险人的承包商或分包商的工作人员所遭受的伤害；"
                                      ),
                                    ]),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(
                                        "（二）在被保险人工作场所内实习、进修人员所遭受的伤害；"
                                      ),
                                    ]),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t（三）除本保险合同列明负责赔偿的项目外，其他超出被保险人雇员所在地工伤保险和基本医疗保险诊疗项目目录、药品目录、医疗服务设施范围和支付标准的医疗费用；\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                    ]),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v("（四）精神损害赔偿；"),
                                    ]),
                                    _c("br"),
                                    _c("span", [_vm._v("（五）间接损失；")]),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v("（六）罚款、罚金及惩罚性赔偿；"),
                                    ]),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t（七）在合同或协议中约定的应由被保险人承担的赔偿责任，但即使没有这种合同或协议，被保险人依法仍应承担的赔偿责任不在本款责任免除范围内；\n\t\t\t\t\t\t\t\t\t"
                                      ),
                                    ]),
                                    _c("br"),
                                    _c("span", [
                                      _vm._v(
                                        "（八）保险单中载明的应由被保险人自行承担的免赔额或按保险单载明的免赔率计算的免赔额。"
                                      ),
                                    ]),
                                    _c("br"),
                                  ])
                                : qa.question ===
                                  "该保险产品有多少种保险期限可选择？如何收费？"
                                ? _c("span", [
                                    _c("span", [
                                      _vm._v(
                                        "共有12种保险期限可选择，1个月-12个月均可选择。"
                                      ),
                                    ]),
                                    _c("br"),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          display: "inline-block",
                                          "margin-left": "25px",
                                          "font-weight": "bold",
                                          "margin-bottom": "10px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t短期保单保费=年保费*比例。\n\t\t\t\t\t\t\t\t\t"
                                        ),
                                      ]
                                    ),
                                    _c("br"),
                                    _c(
                                      "table",
                                      {
                                        attrs: {
                                          border: "1",
                                          cellpadding: "10",
                                        },
                                      },
                                      [
                                        _c(
                                          "tr",
                                          _vm._l(
                                            _vm.monthData,
                                            function (item) {
                                              return _c("th", [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(item) +
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                ),
                                              ])
                                            }
                                          ),
                                          0
                                        ),
                                        _c(
                                          "tr",
                                          _vm._l(_vm.rateData, function (item) {
                                            return _c("td", [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(item) +
                                                  "\n\t\t\t\t\t\t\t\t\t\t\t"
                                              ),
                                            ])
                                          }),
                                          0
                                        ),
                                      ]
                                    ),
                                  ])
                                : _c("span", [_vm._v(_vm._s(qa.answer))]),
                            ]),
                            _c("el-divider"),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "投保须知", name: "2" } },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c("h3", [_vm._v("保险条款及须知")]),
                      _c("p", { staticStyle: { "line-height": "32px" } }, [
                        _c("span", [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t本产品由泰康在线财产保险股份有限公司（以下简称“泰康在线”）承保，由泰康在线委托博维保险经纪（以下简称“博维”）有限公司进行销售\n\t\t\t\t\t\t\t"
                          ),
                          _c("br"),
                          _c("span", { staticClass: "link" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t互联网保险信息披露访问链接：\n\t\t\t\t\t\t\t\t"
                            ),
                            _c(
                              "a",
                              {
                                staticStyle: { color: "DodgerBlue" },
                                attrs: {
                                  href: "http://icid.iachina.cn/?columnid_url=201509301401",
                                  target: "_blank",
                                },
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\thttp://icid.iachina.cn/?columnid_url=201509301401\n\t\t\t\t\t\t\t\t"
                                ),
                              ]
                            ),
                          ]),
                        ]),
                        _c("span", [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t泰康在线是世界500强泰康保险集团的全资子公司，成立于2015年，注册资本为人民币40亿元。截至2020年末，公司综合偿付能力充足率209%。泰康在线专注于互联网保险业务的创新开拓，致力于通过“保险+科技”、“保险+服务”的“双生态”战略，，实现保险与科技的深度融合保险金融属性和服务属性的深度结合，打造国际领先的科技型、服务型互联网保险公司。\n\t\t\t\t\t\t"
                          ),
                        ]),
                      ]),
                      _c("p", { staticStyle: { "line-height": "32px" } }, [
                        _c("span", { staticStyle: { "font-weight": "bold" } }, [
                          _vm._v("一、重要告知"),
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t1.1 订立本合同时，投保人应明确了解如下内容，投保人签订保险合同即视为了解并同意如下内容。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t1.2\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "投保前请仔细阅读保险特别约定、保险条款及其中责任免除部分。"
                          ),
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t1.3 保险人就投保人和被保险人的有关情况提出询问，投保人应当如实告知。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t1.4\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t如投保人故意或者因重大过失未履行前款规定的如实告知义务，根据条款约定足以影响合同是否成立或者提高保险费率的，保险人有权解除本合同。\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t1.5\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t如投保人故意不履行如实告知义务，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，并不退还保险费。\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t1.6\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t如投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t但应当退还保险费。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t1.7\n\t\t\t\t\t\t保险人在合同订立时已经知道投保人未如实告知的情况的，保险人不得解除合同；发生保险事故的，保险人应承担给付保险金的责任。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t1.8 保险公司全国统一的客户服务及投诉方式详见如下链接\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _c("span", { staticClass: "link" }, [
                          _c(
                            "a",
                            {
                              staticStyle: { color: "DodgerBlue" },
                              attrs: {
                                href: "http://www.tk.cn/sales/feedback-pc/page/",
                                target: "_blank",
                              },
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\thttp://www.tk.cn/sales/feedback-pc/page/\n\t\t\t\t\t\t\t"
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t1.9\n\t\t\t\t\t\t本保险合同以电子保单形式提供。根据《中华人民共和国民法典》规定，数据电文是合法的合同表现形式，与纸质合同具有同样的法律效力。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t2.0 本保险根据投保单位的需求提供电子发票或纸质专票。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t2.1\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t本保险由博维保险经纪有限公司面向全国销售并提供服务，如有其他疑问，请在投保前联系客服热线400-180-1616进行咨询与确认。\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                      ]),
                      _c("el-divider"),
                      _c("h3", [_vm._v("特别约定")]),
                      _c("div", { staticStyle: { "line-height": "32px" } }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t1、本产品承保的雇员年龄范围为16周岁-65周岁，其中电梯安装和电梯维修人员的年龄范围为16周岁-55周岁。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\n\t\t\t\t\t\t2、本保单扩展24小时人身意外伤害扩展保险条款，该附加险项下每人责任限额为5万元人民币。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t3、本保单扩展第三者责任保险，该附加险项下每次事故责任限额为5万元人民币。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t4、本保单赔偿范围包括雇员误工费，\n\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t经医院证明，对于超过五天期间的误工损失按100元/天的标准赔偿误工费用，赔偿公式为：100x(实际暂时丧失工作能力天数\n\t\t\t\t\t\t\t- 5天)，每次不超过90天，累计不超过180天。\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t5、\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t主险条款第四条第七款（雇员在工作时间和工作岗位，突发疾病死亡或者在48小时之内经抢救无效死亡）赔偿限额为每人每次死亡伤残赔偿限额的20%。\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t6、保单累计责任限额为实际投保人数*每人伤亡责任限额，\n\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "累计责任限额最高不超过1000万，每次事故责任限额最高不超过500万；"
                          ),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t法律费用另计，不含在内\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\n\t\t\t\t\t\t7、工伤事故身故、残疾理赔约定：理赔时提供投保人所在地劳动保障行政部门出具的工伤认定证明、劳动能力鉴定委员会做出的劳动能力鉴定结论，劳动能力鉴定材料（\n\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t如无法提供劳动保障行政部门出具的工伤认定证明，则伤残赔付标准为保单约定赔付金额的50%）。\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t8、除受伤当日紧急抢救外，必须在二级以上（含）公立医院就诊，急诊客户除受伤当日因紧急救治可就近送医外，后续治疗均需转至二级（或二级以上）公立医院。未遵循前述约定的，保险人有权拒绝赔付。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t9、\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t对于进行电梯井道与结构作业的安装工人，本保单只承保其在进行电梯施工工作发生的保险事故，\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _vm._v(
                          "\n\t\t\t\t\t\t进行其他施工过程中发生的保险事故为除外责任。\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t10、从事高空作业人员，必须定期进行身体检查，被保险人的雇员无妨碍从事相应特种作业的器质性心脏病、癫痫病、美尼尔氏症、眩晕症、癔病、震颤麻痹症、精神病、痴呆症以及其它不适应高空作业的人，不得从事高空作业；\n\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t从事高空作业必须配带安全带、安全帽、孔洞须加强围栏或防滑措施，如存在前述疾病或未遵守签署高空作业防范措施，保险公司有权拒绝赔付。\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t10、\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t出险索赔时，对于电梯维修人员，需提供电梯操作证，对于电梯安装工人，需提供岗前培训通过证明文件，否则保险人有权拒绝赔偿。\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t11、\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t北京平谷区密云区、河北省承德市兴隆县中医院、河北省三河市、天津市、辽宁铁岭、河北青龙县、廊坊市、山东禹城、河南信阳下辖的各医疗机构，不在保险公司认可医院范围内，即上述地区医疗机构的发票保险公司不予理赔。\n\t\t\t\t\t\t"
                          ),
                        ]),
                        _c("br"),
                        _vm._v("\n\t\t\t\t\t\t12、\n\t\t\t\t\t\t"),
                        _c("span", { staticClass: "red-bold" }, [
                          _vm._v(
                            "已出险人员（含已报案未理赔和已理赔）不允许变更。"
                          ),
                        ]),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t13、伤残鉴定及给付标准：\n\t\t\t\t\t\t"
                        ),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t\t1）因工作原因导致的意外事故，提供工伤认定并根据《劳动能力鉴定职工工伤与职业病致残等级》（GB/T16180-2014）确定的伤残程度，给付比例表如下：\n\t\t\t\t\t\t"
                        ),
                        _c(
                          "table",
                          { attrs: { border: "1", cellpadding: "10" } },
                          [
                            _c(
                              "tr",
                              _vm._l(_vm.leavelData, function (item, index) {
                                return _c("th", { key: index }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(item) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  ),
                                ])
                              }),
                              0
                            ),
                            _c(
                              "tr",
                              _vm._l(
                                _vm.leavelValueData,
                                function (item, index) {
                                  return _c("td", { key: index }, [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(item) +
                                        "\n\t\t\t\t\t\t\t\t"
                                    ),
                                  ])
                                }
                              ),
                              0
                            ),
                          ]
                        ),
                        _vm._v(
                          "\n\t\t\t\t\t\t2）非工作时间发生的意外事故，按照《人身保险伤残评定标准及代码》（标准编号为JR/T0083-2013)\n\t\t\t\t\t\t确定的伤残程度，给付比例如下：\n\t\t\t\t\t\t"
                        ),
                        _c(
                          "table",
                          { attrs: { border: "1", cellpadding: "10" } },
                          [
                            _c(
                              "tr",
                              _vm._l(_vm.leavelData, function (item, index) {
                                return _c("th", { key: index }, [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(item) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  ),
                                ])
                              }),
                              0
                            ),
                            _c(
                              "tr",
                              _vm._l(
                                _vm.leavelValueData,
                                function (item, index) {
                                  return _c("td", { key: index }, [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(item) +
                                        "\n\t\t\t\t\t\t\t\t"
                                    ),
                                  ])
                                }
                              ),
                              0
                            ),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }